(() => {
  if (window.__lynkGiftCardV21) return;
  window.__lynkGiftCardV21 = true;
  const enable = root => {
    if (typeof root?.lynkChristmasApi?.openLetter !== 'function') return;
    root.querySelectorAll('[data-gift-card-write]').forEach(button => { button.hidden = false; });
  };
  document.addEventListener('lynk:ready', event => enable(event.target));
  const ready = () => document.querySelectorAll('[data-lynk-christmas]').forEach(enable);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[data-gift-card-write]') : null;
    if (!button) return;
    const api = button.closest('[data-lynk-christmas]')?.lynkChristmasApi;
    if (typeof api?.openLetter !== 'function') return;
    event.preventDefault();
    api.openLetter('loved', button);
  });
})();
